import { TherapyJobStatus } from '~/app/enums/TherapyJobStatus';
import { TherapyJobV2 } from '~/app/models/TherapyJobV2';

export const abortTriggered = (tj: Partial<TherapyJobV2>) => {
  return (
    tj.abortionTriggered === true && tj.status !== TherapyJobStatus.ABORTED && tj.status !== TherapyJobStatus.IN_HISTORY
  );
};
